import { defineQuery } from 'next-sanity';

export const getAllBlogPost = defineQuery(
  `  *[_type == "blog" && ($excludeIds == null || !(_id in $excludeIds)) && ($blogCategory == null || category->slug.current == $blogCategory)] | order(coalesce(editedDate, _updatedAt) desc)[0...18]{
      _id,
      title,
      slug,
      editedDate,
      _updatedAt,
      coverMedia {
        ...,
        coverImage {
          ...,
          "imgAsset": asset-> {
            ...
          }
        },
        thumbnail{
          ...,
          "imgAsset": asset-> {
            ...
          }
        }
      },
      shortSummary,
      content
     }`
);

export const getBlogbySlug = defineQuery(`
    *[_type == "blog" && slug.current == $slug][0]{
    ...,
    coverMedia {
      ...,
      coverImage {
        ...,
        "imgAsset": asset-> {
          ...
        }
      },
      thumbnail{
        ...,
        "imgAsset": asset-> {
          ...
        }
      }
    },
    author->{
    name,
    profileImage {
      ...,
      "imgAsset": asset-> {
        ...,
      }
    }
    }, 
    content[]{
      ...,
      markDefs[]{...,
        _type == "internalLink" => { 
        "slug": @.reference->slug.current,
         "type":@.reference->_type     
         }
      },
      _type == "image" => {
        ...,
        asset-> {
          ...,
        }
      }
    },
    "text": pt::text(content),
    category->{title, slug, _id},
    editedDate,
    _createdAt,
     "relatedBlogs": *[_type == "blog" && _id != ^._id && defined(keyword) && keyword._ref == ^.keyword._ref][0...2] {
     _id,
      title,
      coverMedia {
        ...,
        coverImage {
          ...,
          "imgAsset": asset-> {
            ...
          }
        },
        thumbnail{
          ...,
          "imgAsset": asset-> {
            ...
          }
        }
      },
      slug,
    },
    metaDescription,
    testimonial->{
      name,
      content,
      country
    },
    "randomTestimonialCount": select(
      testimonial == null => count(*[_type == "testimonial" && includeInRandom == true]),
      null
    ),
    JS, CSS
    }
  `);

export const getBlogSetting = defineQuery(`
    *[_type == "blogSetting"]{
    title,
    header,
    metaDescription,
    _createdAt,
    JS, CSS,
    heroPost->{
      _id,
      _createdAt,
      editedDate,
      _updatedAt,
      title,
      author->{
        name,
        profileImage{
          ...,
          "imgAsset": asset-> {
            ...,
          }
        }
      },
      coverMedia {
        ...,
        coverImage {
          ...,
          "imgAsset": asset-> {
            ...
          }
        },
        thumbnail{
          ...,
          "imgAsset": asset-> {
            ...
          }
        }
      },
      metaDescription ,
      slug,
      content,
    },
    "categoryHeroPosts": categoryHeroPosts[category->slug.current == $heroCategory]{
       heroPost->{
        _id,
      _createdAt,
      _updatedAt,
      editedDate,
      title,
      author->{
        name,
        profileImage{
          ...,
          "imgAsset": asset-> {
            ...
          }
        }
      },
      coverMedia {
        ...,
        coverImage{
          ...,
          "imgAsset": asset-> {
            ...
          }
        },
        thumbnail{
          ...,
          "imgAsset": asset-> {
            ...
          }
        }
      },
      metaDescription ,
      slug,
      content,
    },
      category->{
        title,
        slug
      }
    }
  }`);

export const GetBlogLoadmorePosts = defineQuery(`
    {
    "posts":*[
      _type == "blog" && 
      ($category == null || category->slug.current == $category) &&
       (
    editedDate < $lastEditedDate
    || (editedDate == $lastEditedDate && _updatedAt > $updatedAt)
  ) && 
      ($excludeIds == null || !(_id in $excludeIds))
    ] | order(coalesce(editedDate, _updatedAt) desc) [0...$limit]{
    _id,
    editedDate,
    _updatedAt,
      title,
      slug,
      coverMedia {
        ...,
        coverImage {
          ...,
          "imgAsset": asset-> {
            ...
          }
        },
        thumbnail{
          ...,
          "imgAsset": asset-> {
            ...
          }
        }
      },
      shortSummary,
      content 
    },
    "totalPosts":count(
      *[
      _type == "blog" && 
      ($category == null || category->slug.current == $category) &&
      (
    editedDate < $lastEditedDate
    || (editedDate == $lastEditedDate && _updatedAt > $updatedAt)
  ) && 
      ($excludeIds == null || !(_id in $excludeIds))
    ] | order(coalesce(editedDate, _updatedAt) desc)
    )
    }
    `);

export const getBlogListSeoData = defineQuery(`
     *[_type == "blogSetting"]{
     title,
      metaDescription,
     }
    `);

export const getBlogDetailSeoData = defineQuery(`
     *[_type == "blog" && slug.current == $slug][0]{
     title,
     slug,
     metaDescription,
     coverMedia,
     content
     }
    `);

export const getBlogDate = defineQuery(`
  {
    "dateModified": *[_type == "blog"] | order(_updatedAt desc)[0]._updatedAt,
    "datePublished": *[_type == "blog"] | order(_createdAt asc)[0]._createdAt
  }
  `);

export const getAllBlogSlugs = defineQuery(`
  *[_type == "blog" && defined(slug.current)][].slug.current`);
